import type { ReactNode } from 'react';
import { PaginaAyuda, Captura, Pasos } from '../shared/Ayuda.tsx';

export function AyudaPersonalPage(): ReactNode {
  return (
    <PaginaAyuda
      titulo="Manual de la app"
      intro="Cómo usar cada pantalla, en simple."
      accent="azul"
      secciones={[
        {
          id: 'convocatorias',
          titulo: 'Convocatorias: te ofrecen un trabajo',
          contenido: (
            <>
              <p>
                Cuando hay un servicio para vos, te llega una notificación y aparece acá con fecha, horario, salón y
                función. <strong>Tenés un plazo para responder</strong> (viene marcado en la tarjeta): si se vence, el
                trabajo pasa al siguiente de la lista.
              </p>
              <Pasos
                items={[
                  <>Tocá <strong>✓ Aceptar</strong> y el servicio queda tuyo: pasa a tu Agenda.</>,
                  <>Tocá <strong>✕ Rechazar</strong> si no podés — no pasa nada, se convoca a otro.</>,
                  <>Las urgentes (menos de 48 h) aparecen destacadas y vencen más rápido.</>,
                ]}
              />
              <Captura src="personal-convocatorias.png" alt="Convocatorias pendientes" pie="Una convocatoria esperando tu respuesta." />
            </>
          ),
        },
        {
          id: 'agenda',
          titulo: 'Mi agenda: tus servicios confirmados',
          contenido: (
            <>
              <p>
                Todo lo que aceptaste, ordenado por semana (Hoy, Esta semana, Semana que viene). Si te surge algo y no
                podés ir, abrí el servicio y tocá <strong>Cancelar servicio</strong>: te pide el motivo y avisa al
                administrador (si faltan menos de 24 horas queda marcada como cancelación tardía — evitalas).
              </p>
              <Captura src="personal-agenda.png" alt="Mi agenda" pie="Tus servicios confirmados por semana." />
            </>
          ),
        },
        {
          id: 'disponibilidad',
          titulo: 'Disponibilidad: cuándo podés trabajar',
          contenido: (
            <>
              <p>
                Marcá tus días y horarios disponibles de la semana — el sistema solo te convoca dentro de esos
                horarios. Si un día puntual no podés (un cumpleaños, un viaje), agregá un <strong>bloqueo</strong> en
                esa fecha y ese día no te llega nada.
              </p>
              <p>Mantenela al día: cuanta más disponibilidad tengas cargada, más trabajos te pueden ofrecer.</p>
              <Captura src="personal-disponibilidad.png" alt="Disponibilidad semanal" pie="Tus horarios disponibles y bloqueos." />
            </>
          ),
        },
        {
          id: 'checkin',
          titulo: 'Check-in: marcar llegada y salida',
          contenido: (
            <>
              <Pasos
                items={[
                  <>Al llegar al salón, abrí <strong>Check-in</strong> y marcá la llegada: por <strong>GPS</strong> (tenés que estar en el salón) o escaneando el <strong>QR</strong> de la pantalla del local.</>,
                  <>Al irte, marcá la salida igual.</>,
                  <>¿Marcaste mal? Volvé a marcar: la nueva marca con la hora actual reemplaza la equivocada.</>,
                  <>Abajo tenés tu historial de marcas de los últimos meses.</>,
                ]}
              />
              <Captura src="personal-checkin.png" alt="Pantalla de check-in" pie="Marcar llegada del servicio de hoy." />
            </>
          ),
        },
        {
          id: 'historial',
          titulo: 'Historial: lo que ya pasó',
          contenido: (
            <p>
              Tus convocatorias viejas, mes por mes. Con el tachito 🗑 podés limpiar el historial de tu app: las
              convocatorias viejas dejan de verse para vos (la empresa conserva sus registros, no afecta tus pagos).
            </p>
          ),
        },
        {
          id: 'pagos',
          titulo: 'Mis pagos',
          contenido: (
            <p>
              Acá aparecen tus liquidaciones: los turnos trabajados de cada período con las horas y el monto, y si ya
              está pagada o pendiente. Si un número no te cierra, hablá con el administrador.
            </p>
          ),
        },
      ]}
    />
  );
}
